export default __webpack_public_path__ + "static/media/IMG_5554.4422d78d.jpg";